import { SHOW_COMPLEMENTARY_PRODUCTS_DRAWER, SET_ADDED_PRODUCT, SET_COMPLEMENTARY_PRODUCTS, CLOSE_COMPLEMENTARY_PRODUCTS_DRAWER } from "../Actions/ComplementaryProductsDrawer.action"
import { error as errorReducer } from "./Error.reducer"

const defaultState = {
    showDrawer: false,
    addedProduct: null,
    products: [],
}

export const complementaryProducts = (state = defaultState, action) => {
    const { type, payload } = action
    switch (type) {
        case SHOW_COMPLEMENTARY_PRODUCTS_DRAWER:
            return {
                ...state,
                showDrawer: true,
            }
        case SET_ADDED_PRODUCT:
            return {
                ...state,
                addedProduct: payload.addedProduct,
            }
        case SET_COMPLEMENTARY_PRODUCTS:
            return {
                ...state,
                products: payload.products,
            }
        case CLOSE_COMPLEMENTARY_PRODUCTS_DRAWER:
            return {
                ...state,
                showDrawer: false,
                addedProduct: null,
                products: [],
            }
        default:
            return state
    }
}
